export const namespaced = true;

import CorporationService from '@/services/CorporationService.js';
import map from 'lodash/map';
import pick from 'lodash/pick';
import { basicPresent, basicProductName } from '@/presenters/fields';

export const state = {
  corporations: [],
  corporation: {},
  editingCorporation: null,
};

export const mutations = {
  SET_CORPORATIONS(state, corporations) {
    state.corporations = corporations;
  },
  CLEAR_CORPORATIONS(state) {
    state.corporations = [];
  },
  SET_CORPORATION(state, corporation) {
    state.corporation = corporation;
  },
  SET_EDITING_CORPORATION(state, corporation) {
    state.editingCorporation = corporation;
  },
  DELETE_EDITING_CORPORATION(state) {
    state.editingCorporation = null;
  },
  UPDATE_CORPORATION(state, corporation) {
    state.corporation = corporation;
  },
  ADD_CORPORATION(state, corporation) {
    state.corporation = corporation;
  },
  CHANGE_CORPORATION_PASSWORD() {
    // We don't store Password inside Vuex, so we don't need to do anything here
  },
  FREEZE_CORPORATION() {
    // We only freeze Corporation, so we don't need to do anything here
  },
};

export const actions = {
  setCurrentCorporationUser({ commit }, corporation) {
    commit('SET_CORPORATION', corporation);
  },
  fetchCorporations({ commit }) {
    return CorporationService.all().then((response) => {
      commit('SET_CORPORATIONS', response.data);
    });
  },
  clearCorporations({ commit }) {
    commit('CLEAR_CORPORATIONS');
  },
  fetchCorporation({ commit }, id) {
    return CorporationService.get(id).then((response) => {
      commit('SET_CORPORATION', response.data);
      return response.data;
    });
  },
  startEditingCorporation({ commit }, corporation) {
    commit('SET_EDITING_CORPORATION', corporation);
  },
  finishEditingCorporation({ commit, state }, id) {
    if (state.editingCorporation) {
      if (id) {
        return CorporationService.update(id, state.editingCorporation).then((response) => {
          commit('DELETE_EDITING_CORPORATION');
          commit('UPDATE_CORPORATION', response.data);
        });
      } else {
        return CorporationService.create(state.editingCorporation).then((response) => {
          commit('DELETE_EDITING_CORPORATION');
          commit('ADD_CORPORATION', response.data);
        });
      }
    }
  },
  clearEditingCorporation({ commit, state }) {
    if (state.editingCorporation) {
      commit('DELETE_EDITING_CORPORATION');
    }
  },
  changeCorporationPassword({ commit }, { id, password }) {
    return CorporationService.changePassword(id, password).then(() => {
      commit('CHANGE_CORPORATION_PASSWORD');
    });
  },
  freezeCorporation({ commit }, payload) {
    let formattedFrozenData = {};
    if (payload.frozenMonth != 'now') {
      formattedFrozenData['frozenDatetime'] = payload.frozenMonth;
    }
    return CorporationService.frozen(payload.id, formattedFrozenData).then(() => {
      commit('FREEZE_CORPORATION');
    });
  },
};

export const getters = {
  getCorporationById: (state) => (id) => {
    return state.corporations.find((item) => item.id == id);
  },
  totalCorporations: (state) => {
    return state.corporations.length;
  },
  getExcelFormattedCorporations: (state) => (fields) => {
    return map(state.corporations, (corporation) => {
      let data = {
        法人ID: basicPresent(corporation.uid),
        法人名: basicPresent(corporation.name),
        利用教材: basicProductName(corporation.figuredProducts),
      };

      return pick(data, fields);
    });
  },
  existsRegistrationRequiredParams: (state) => {
    if (!state.editingCorporation.uid) return false;
    if (!state.editingCorporation.password) return false;
    if (!state.editingCorporation.name) return false;
    if (!state.editingCorporation.nameReading) return false;
    if (!state.editingCorporation.postalCode) return false;
    if (!state.editingCorporation.state) return false;
    if (!state.editingCorporation.address) return false;
    if (!state.editingCorporation.phone) return false;
    if (!state.editingCorporation.figuredProducts.length > 0) return false;

    return true;
  },
  existsUpdateRequiredParams: (state) => {
    if (!state.editingCorporation.name) return false;
    if (!state.editingCorporation.nameReading) return false;
    if (!state.editingCorporation.postalCode) return false;
    if (!state.editingCorporation.state) return false;
    if (!state.editingCorporation.address) return false;
    if (!state.editingCorporation.phone) return false;
    if (!state.editingCorporation.figuredProducts.length > 0) return false;

    return true;
  },
};
